import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

export enum AccountRoles {
    SystemAdmin = 0,
    ProductAdmin = 1,
    PlatformAdmin = 2,
    WebtagAdmin = 3,
    NormalUser = 4,
}

export interface LoginUser {
    account_id: string;
    account_email: string;
    account_name: string;
}

@Injectable({ providedIn: 'root' })
export class LanguageService {

    constructor() {}

    public languageLoadingSubject: Subject<boolean> = new Subject<boolean>();
    public languageLoading: Observable<boolean> = this.languageLoadingSubject.pipe(debounceTime(100));

}
